import {
  getURLParamValue
} from './_getURLParamValue'

//Inserts Url in breadcrumbs back to browsing link
export var breadCrumbs = () => {
  var facets = getURLParamValue("facetCache").length > 0 ? decodeURIComponent(getURLParamValue("facetCache")) : '',
    context = (facets !== '') ? '#' + facets : '',
    b2bUrl = document.referrer,
    backToBrowsingURL = b2bUrl !== '' ? b2bUrl.replace(/ /g, '+') : document.referrer,
    validB2BrowsingArray = ["/c/", "/shop/", "/content/", "/search-term/", "/chanel/", "/brand/"],
    validDomain = ["dillards.com", "localhost"],
    fromReviewForm = ["/ReviewForm"];

  function contains(str, substrings) {
    for (var i = 0; i <= substrings.length; i++) {
      var substring = substrings[i];
      if (str.indexOf(substring) != -1) return substring;
    }
    return null;
  }
};
